import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { IconPhotoDollar, IconSignature } from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";
import { useSelector } from "react-redux";

import NavBar from "../../components/NavBar/NavBar";
import { RootState } from "../../store";
import { useStyles } from "./Borrowerlayout.styles";

interface IProps {
  content: ReactNode;
}

const BorrowerLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();
  // Menu items stay hidden until the merchant has a credit limit — the
  // Collaboration Proposal flow can't proceed without one.
  const hasCreditLimit = useSelector((state: RootState) => state.auth.hasCreditLimit);

  const menus = [
    // {
    //   label: "Dashboard",
    //   path: "/merchant-dashboard/Overall",
    //   icon: <IconHome />,
    // },
    {
      label: "Collaboration Proposal",
      path: "/collaboration-proposal/application",
      icon: <IconPhotoDollar />,
    },
    {
      label: "Signed Documents",
      path: "/signed-documents",
      icon: <IconSignature />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      <NavBar menus={menus} canPassCondition={hasCreditLimit} />
      <div style={{ paddingBottom: "30px" }} className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default BorrowerLayout;
